export enum EmployeeActivationStatus {
    ACTIVATE = 'ACTIVATE',
    DEACTIVATE = 'DEACTIVATE',
    SUSPEND = "SUSPEND"
}